import React, {useEffect, useState} from 'react';
import { useFetch } from "../../../../components/common/FetchProvider";
import Loader from "components/Loader/Loader";
import CommonTable from "./CommonTable";
import OrganModal from "./OrganModal";
import { columnsDataOrgans } from "../variables/columnsData";


const OrgansTable = () => {
    const fetchWrapper = useFetch();
    const [loading, setLoading] = useState(false);
    const [apiData, setApiData] = useState([]);
    const [error, setError] = useState(false);
    const [organizationData, setOrganizationData] = useState(null);

    useEffect(() => {
        setOrganizationData(null);
        fetchData();
    }, []);

    const fetchData = async () => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/organization`;

            const userToken = localStorage.getItem("token");
            const response = await fetchWrapper(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data && responseData.data.length > 0) {
                    setApiData(responseData.data);
                } else {
                    setError(true);
                }
            } else {
                setError(true);
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            setError(true);
            console.error('Error fetching API data:', error);
        }
    };

    const mappedApiData = apiData.map((item) => ({
        id: item.id,
        name: item.name,
        status: item.status,
        sigfe: item.sigfe ? "Sim" : "Não"
    }));

    const [showModal, setShowModal] = useState(false);
    const handleLinkClick = () => {
        setShowModal(true);
    };

    const refreshData = () => {
        reload();
    }

    const reload = () => {
        setApiData([]);
        setOrganizationData(null);
        fetchData();
    };

    const handleActionClick = (rowData) => {
        let data = apiData.find((item) => item.id === rowData.id);
        setOrganizationData(data);
        handleLinkClick();
    };

    return (
        <div className="10">
            <Loader show={loading}/>
            <header className="w-full pb-2 p-4 h-full relative flex items-center justify-between">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Orgãos
                </div>
                {/* Links with Separator */}
                <div className="flex justify-center items-center font-bold text-brand-600">
                    <button onClick={handleLinkClick}>Cadastrar</button>
                    {showModal && (
                        <OrganModal
                            showModal={showModal}
                            setModalState={setShowModal}
                            refreshData={refreshData}
                            organizationData={organizationData}
                            setOrganizationData={setOrganizationData}
                        />
                    )}
                </div>

            </header>
            <div className="mt-1">
                {loading ? (
                    <div></div>
                ) : apiData && apiData.length > 0 ? (
                    <CommonTable
                        columnsData={columnsDataOrgans}
                        tableData={mappedApiData}
                        onActionClick={handleActionClick}
                    />
                ) : (
                    <></>
                )}
            </div>
        </div>
    )
        ;
}

export default OrgansTable;
